export { Favourites } from './Favourites';
export { FavouritesRecipes } from './Recipes';
export { FavouritesVideos } from './Videos';
export { FavouritesWorkouts } from './Workouts';



// WEBPACK FOOTER //
// ./src/containers/Favourites/index.js